// extracted by mini-css-extract-plugin
module.exports = {"title":"title_title___da_j","both":"title_both__S_cSq","no_line":"title_no_line__3uG8u"};